/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ date: NonNullable<unknown> }} Seat_Types_Card_WaitingInputs */



/**
* | output |
* | --- |
* | "Changes waiting for your renewal on {date}" |
*
* @param {Seat_Types_Card_WaitingInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const seat_types_card_waiting = /** @type {((inputs: Seat_Types_Card_WaitingInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Seat_Types_Card_WaitingInputs, { locale?: "en" | "de" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ (`Geplante Änderungen zu Ihrer Verlängerung am ${i?.date}`)
	return /** @type {LocalizedString} */ (`Changes waiting for your renewal on ${i?.date}`)
});